import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    Renderer2,
} from '@angular/core';
import { HomePageService } from '../../home-page/home-page.service';
import { MediaCDNService } from '../../@core/media-cdn.service';

@Component({
    selector: 'app-one-col-banner-v2',
    templateUrl: './one-col-banner-v2.component.html',
    styleUrls: ['./one-col-banner-v2.component.scss'],
})
export class OneColBannerV2Component implements OnInit {
    @Input() item: any;
    @Input() borderRadius = '0px';
    @Output() emitLink: EventEmitter<string> = new EventEmitter();

    isMobile = false;

    constructor(
        public homepageService: HomePageService,
        public mediaCDN: MediaCDNService
    ) {}

    ngOnInit(): void {
        this.isMobile =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent
            );
    }

    processLink(link: string) {
        this.emitLink.emit(link);
    }

    getBottomContentStyle(): { [key: string]: string } {
        const alignment = this.item?.layoutContent?.alignment;
        const padding = this.item?.layoutContent?.padding || {};
        const adjustment = this.isMobile ? 28 : 80;

        const styles: { [key: string]: string } = {};

        switch (alignment) {
            case 'center-end':
                styles.alignItems = 'center';
                break;
            case 'end-end':
                styles.right = padding.right
                    ? `${padding.right + adjustment}px`
                    : `${adjustment}px`;
                break;
            default:
                styles.left = padding.left
                    ? `${padding.left + adjustment}px`
                    : `${adjustment}px`;
                break;
        }

        return styles;
    }

    getBottomContentAlignment(): string {
        const alignment = this.item?.layoutContent?.alignment;

        switch (alignment) {
            case 'center-end':
                return 'center end';
            case 'end-end':
                return 'end end';
            default:
                return 'start end';
        }
    }

    getStyles(): { [key: string]: string } {
        const padding = this.item?.layoutContent?.padding || {};
        const styles: { [key: string]: string } = {};

        ['top', 'bottom', 'left', 'right'].forEach(side => {
            if (padding[side]) {
                const propertyPrefix = ['top', 'bottom'].includes(side)
                    ? 'margin'
                    : 'padding';
                styles[
                    `${propertyPrefix}${side
                        .charAt(0)
                        .toUpperCase()}${side.slice(1)}`
                ] = `${padding[side]}px`;
            }
        });

        return styles;
    }
}
